// extracted by mini-css-extract-plugin
module.exports = {"popover":"src-components-app-header-Support-module__popover--3edMT"};